<template>
  <div style="text-align:left;">
    <TopNav />
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <div v-if="admin_datos.superadmin" class="main-container">
        <div v-if="loaded" class="articulo-principal">
          <div class="tabs">
            <button class="tab-btn" :class="{ active: activeTab === 'aplicantes' }" @click="activeTab = 'aplicantes'">Aplicantes</button>
            <button class="tab-btn" :class="{ active: activeTab === 'onboarding' }" @click="activeTab = 'onboarding'">Onboarding</button>
            <button class="tab-btn" :class="{ active: activeTab === 'b2b_leads' }" @click="activeTab = 'b2b_leads'">Leads B2B</button>
          </div>

          <div v-if="activeTab === 'aplicantes'">
            <p>Estas son las aplicaciones recibidas en la plataforma.</p>
            <div class="filters">
              <div class="filter-group">
                <label for="factura-select">Factura:</label>
                <select id="factura-select" v-model="selectedFactura" @change="addFactura">
                  <option disabled value="">Seleccione</option>
                  <option value="empresa">Empresa</option>
                  <option value="persona_natural">Persona Natural</option>
                  <option value="no">No</option>
                </select>
              </div>
              <div class="filter-group">
                <label for="region-select">Región:</label>
                <select id="region-select" v-model="selectedRegion" @change="addRegion">
                  <option disabled value="">Seleccione</option>
                  <option v-for="r in regiones" :key="r.id" :value="r.id">{{ r.Nombre }}</option>
                </select>
              </div>
              <div class="filter-group">
                <label for="phone-select">Tipo Teléfono:</label>
                <select id="phone-select" v-model="selectedPhone" @change="addPhone">
                  <option disabled value="">Seleccione</option>
                  <option value="android">Android</option>
                  <option value="iphone">iPhone</option>
                  <option value="otros">Otros</option>
                </select>
              </div>
              <div class="filter-group">
                <label for="contact-select">Contacto:</label>
                <select id="contact-select" v-model="selectedContactStatus">
                  <option value="all">Todos</option>
                  <option value="contacted">Solo contactados</option>
                  <option value="uncontacted">Solo sin contacto</option>
                </select>
              </div>
              <div class="filter-group">
                <label for="whatsapp-read-select">WhatsApp:</label>
                <select id="whatsapp-read-select" v-model="selectedWhatsappReadStatus">
                  <option value="all">Todos</option>
                  <option value="unread">Con no leidos</option>
                  <option value="read">Sin no leidos</option>
                </select>
              </div>
              <div class="filter-group">
                <label for="onboarding-select">Onboarding:</label>
                <select id="onboarding-select" v-model="selectedOnboardingStatus">
                  <option value="without">Sin onboarding</option>
                  <option value="with">Con onboarding</option>
                  <option value="all">Todos</option>
                </select>
              </div>
              <div class="tags">
                <span class="tag" v-for="f in filterFactura" :key="`factura-${f}`">
                  Factura: {{ formatFactura(f) }}
                  <button class="remove-tag" @click="removeFactura(f)">×</button>
                </span>
                <span class="tag" v-for="r in filterRegion" :key="`region-${r}`">
                  Región: {{ getRegionName(r) }}
                  <button class="remove-tag" @click="removeRegion(r)">×</button>
                </span>
                <span class="tag" v-for="p in filterPhoneType" :key="`phone-${p}`">
                  Teléfono: {{ formatPhone(p) }}
                  <button class="remove-tag" @click="removePhone(p)">×</button>
                </span>
              </div>
            </div>

            <table class="tablex">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>Servicios</th>
                  <th>Email</th>
                  <th>Teléfono</th>
                  <th>Tipo Teléfono</th>
                  <th>Fecha de Aplicación</th>
                  <th>Revisado</th>
                  <th>Contacto</th>
                  <th>Comentarios</th>
                  <th>Onboarding</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="app in filteredApplications" v-if="app && app.id">
                  <tr :key="`app-${app.id}`" :title="`Razón: ${app.porque || 'No especificado'}\nExperiencia: ${app.experiencia || 'No especificada'}`" @click="toggleDetails(`app-${app.id}`)" :class="{'clickable-row': true}">
                    <td>{{ app.id }}</td>
                    <td>{{ app.nombre }} {{ app.apellido }}</td>
                    <td class="services-cell">
                      <span v-if="app.categorias && app.categorias.length">{{ formatList(app.categorias) }}</span>
                      <span v-else>N/A</span>
                    </td>
                    <td>{{ app.email }}</td>
                    <td>{{ app.telefono }}</td>
                    <td>{{ app.tipo_telefono || 'N/A' }}</td>
                    <td>{{ formatDate(app.created_at) }}</td>
                    <td @click.stop="markAsReviewed(app.id, app.reviewed)">
                      <input type="checkbox" v-model="app.reviewed">
                    </td>
                    <td>
                      <span class="contact-status" :class="{ contacted: app.whatsapp_contacted }">
                        {{ app.whatsapp_contacted ? 'Contactado' : 'Sin contacto' }}
                      </span>
                      <button
                        v-if="!app.whatsapp_contacted"
                        type="button"
                        class="quick-whatsapp-button"
                        :disabled="isAplicanteWhatsappSending(app.id)"
                        @click.stop="sendAplicanteWhatsappInitialContact(app)"
                      >
                        {{ isAplicanteWhatsappSending(app.id) ? 'Enviando...' : 'Primer contacto' }}
                      </button>
                      <div v-if="app.whatsapp_contacted" class="contact-meta">
                        {{ app.whatsapp_message_count || 0 }} mensajes
                        <span v-if="app.whatsapp_last_message_at">· {{ formatDate(app.whatsapp_last_message_at) }}</span>
                      </div>
                      <div v-if="Number(app.whatsapp_unread_count || 0) > 0" class="unread-badge">
                        {{ app.whatsapp_unread_count }} no leido{{ Number(app.whatsapp_unread_count) === 1 ? '' : 's' }}
                      </div>
                    </td>
                    <td @click.stop>
                      <span v-if="!editing[app.id]">{{ app.commentaries || 'Sin comentarios' }}</span>
                      <input v-else v-model="app.commentaries" @blur="saveComentarios(app.id, app.commentaries)">
                      <button v-if="!editing[app.id]" @click.stop="startEditing(app.id)">Editar</button>
                      <button v-if="editing[app.id]" @click.stop="cancelEditing(app.id)">Cancelar</button>
                    </td>
                    <td @click.stop>
                      <span v-if="app.onboarding" class="pill" :class="getOnboardingStatusClass(app.onboarding.status)">
                        {{ formatOnboardingStatus(app.onboarding.status) }}
                      </span>
                      <span v-else class="pill pill-neutral">Sin onboarding</span>
                    </td>
                    <td @click.stop>
                      <button
                        class="onboarding-invite-button"
                        :class="{ associated: !!app.onboarding }"
                        :disabled="!!app.onboarding"
                        @click.stop="openAplicanteOnboardingModal(app)"
                      >
                        <span class="onboarding-invite-icon">{{ app.onboarding ? '✓' : '+' }}</span>
                        <span>{{ app.onboarding ? 'Onboarding asociado' : 'Invitar onboarding' }}</span>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="isRowExpanded(`app-${app.id}`)" class="detail-row" :key="`app-details-${app.id}`">
                    <td colspan="12">
                      <div><strong>Puede facturar:</strong> {{ app.factura_habilitado || 'No especificado' }}</div>
                      <div><strong>Servicios:</strong> {{ formatList(app.categorias) }}</div>
                      <div><strong>Razón:</strong> {{ app.porque || 'No especificado' }}</div>
                      <div><strong>Experiencia:</strong> {{ app.experiencia || 'No especificada' }}</div>
                      <div><strong>Comunas:</strong> <span v-for="c in app.comunas" :key="`${app.id}-${c}`">{{ c }} </span></div>
                      <div v-if="app.onboarding">
                        <strong>Onboarding:</strong>
                        {{ formatOnboardingStatus(app.onboarding.status) }}
                        · {{ formatOnboardingTipo(app.onboarding.tipo_profesional) }}
                        <a v-if="app.onboarding.form_url" :href="app.onboarding.form_url" target="_blank" rel="noopener noreferrer">Abrir formulario</a>
                      </div>
                      <section class="applicant-whatsapp-panel" @click.stop :ref="getAplicanteWhatsappPanelRef(app.id)">
                        <div class="panel-header">
                          <h4>WhatsApp</h4>
                          <span class="panel-meta">{{ app.telefono || 'Sin telefono' }}</span>
                        </div>
                        <div v-if="getAplicanteWhatsappWarnings(app.id).length" class="context-warning">
                          Este telefono tambien tiene mensajes asociados a {{ getAplicanteWhatsappWarnings(app.id).join(', ') }}.
                        </div>
                        <div
                          v-if="getAplicanteWhatsappError(app.id) && !getAplicanteWhatsappMessages(app.id).length"
                          class="panel-body error"
                        >
                          {{ getAplicanteWhatsappError(app.id) }}
                        </div>
                        <div
                          v-else-if="isAplicanteWhatsappLoading(app.id) && !getAplicanteWhatsappMessages(app.id).length"
                          class="panel-body"
                        >
                          Cargando conversacion...
                        </div>
                        <div
                          v-else-if="getAplicanteWhatsappMessages(app.id).length"
                          class="panel-body messages"
                          :ref="getAplicanteWhatsappMessagesRef(app.id)"
                        >
                          <div
                            v-for="message in getAplicanteWhatsappMessages(app.id)"
                            :key="`app-wsp-${app.id}-${message.id}`"
                            class="message-row"
                            :class="mapWhatsappSenderClass(message)"
                          >
                            <div class="message-meta">
                              <span class="sender">{{ mapWhatsappSenderLabel(message) }}</span>
                              <span class="timestamp">{{ formatDateTime(message.occurred_at || message.created_at) }}</span>
                            </div>
                            <div class="message-text">{{ getWhatsappMessageText(message) }}</div>
                          </div>
                        </div>
                        <div v-else class="panel-body empty-messages">No hay conversacion WhatsApp registrada.</div>
                        <div
                          v-if="getAplicanteWhatsappError(app.id) && getAplicanteWhatsappMessages(app.id).length"
                          class="whatsapp-inline-error"
                        >
                          {{ getAplicanteWhatsappError(app.id) }}
                        </div>
                        <div class="whatsapp-composer-shell">
                          <div
                            v-if="isAplicanteWhatsappEmojiOpen(app.id)"
                            class="whatsapp-emoji-picker"
                          >
                            <button
                              v-for="emoji in commonWhatsappEmojis"
                              :key="`app-wsp-emoji-${app.id}-${emoji}`"
                              type="button"
                              class="emoji-option"
                              :title="emoji"
                              @click.stop="insertAplicanteWhatsappEmoji(app.id, emoji)"
                            >
                              {{ emoji }}
                            </button>
                          </div>
                          <div class="whatsapp-composer">
                            <textarea
                              :ref="getAplicanteWhatsappTextareaRef(app.id)"
                              :value="getAplicanteWhatsappDraft(app.id)"
                              @input="setAplicanteWhatsappDraft(app.id, $event.target.value)"
                              placeholder="Escribe al postulante por WhatsApp..."
                              :disabled="isAplicanteWhatsappSending(app.id)"
                            ></textarea>
                            <div class="whatsapp-composer-actions">
                              <button
                                type="button"
                                class="emoji-toggle-button"
                                :class="{ active: isAplicanteWhatsappEmojiOpen(app.id) }"
                                :disabled="isAplicanteWhatsappSending(app.id)"
                                title="Emojis"
                                @click.stop="toggleAplicanteWhatsappEmojiPicker(app.id)"
                              >
                                😊
                              </button>
                              <button
                                type="button"
                                :disabled="!canSendAplicanteWhatsapp(app.id)"
                                @click.stop="sendAplicanteWhatsappMessage(app)"
                              >
                                {{ isAplicanteWhatsappSending(app.id) ? 'Enviando...' : 'Enviar' }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </section>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>

          <div v-else-if="activeTab === 'onboarding'">
            <div class="onboarding-header">
              <div>
                <h3>Solicitudes de onboarding profesional</h3>
                <p class="onboarding-subtitle">Revisa estado, documentos, datos bancarios y evidencia de trabajos en un solo lugar.</p>
              </div>
              <div class="onboarding-count">
                {{ onboardingRequestsLoading ? 'Cargando...' : onboardingRequestsCountLabel }}
              </div>
            </div>
            <div class="filters">
              <div class="filter-group">
                <label for="onboarding-region-select">Región:</label>
                <select id="onboarding-region-select" v-model="selectedOnboardingRegion" @change="addOnboardingRegion">
                  <option disabled value="">Seleccione</option>
                  <option v-for="r in regiones" :key="`onboarding-region-option-${r.id}`" :value="r.id">
                    {{ r.Nombre }}
                  </option>
                </select>
              </div>
              <div class="tags">
                <span class="tag" v-for="r in filterOnboardingRegion" :key="`onboarding-region-${r}`">
                  Región: {{ getRegionName(r) }}
                  <button class="remove-tag" @click="removeOnboardingRegion(r)">×</button>
                </span>
              </div>
            </div>
            <div v-if="onboardingRequestsError" class="error-message">
              {{ onboardingRequestsError }}
              <button type="button" @click="fetchOnboardingRequests">Reintentar</button>
            </div>
            <table class="tablex">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>Email</th>
                  <th>Tipo</th>
                  <th>Estado</th>
                  <th>Contrato</th>
                  <th>Enviado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="onboardingRequestsLoading">
                  <td colspan="8">Cargando solicitudes...</td>
                </tr>
                <tr v-else-if="!onboardingRequestsError && !filteredOnboardingRequests.length">
                  <td colspan="8">
                    {{ filterOnboardingRegion.length
                      ? 'No hay solicitudes de onboarding para las regiones seleccionadas.'
                      : 'No hay solicitudes de onboarding para mostrar.' }}
                  </td>
                </tr>
                <template v-for="req in filteredOnboardingRequests" v-if="req && req.id">
                  <tr :key="`onb-${req.id}`" class="clickable-row onboarding-main-row" @click="toggleOnboardingDetails(req)">
                    <td>{{ req.id }}</td>
                    <td>{{ req.nombre }} {{ req.apellido }}</td>
                    <td>{{ req.email }}</td>
                    <td>
                      <span class="pill pill-neutral">{{ req.tipo_profesional || 'N/A' }}</span>
                    </td>
                    <td>
                      <span class="pill" :class="statusClass(req.status)">{{ req.status || 'N/A' }}</span>
                    </td>
                    <td>{{ requiresContract(req) ? (req.has_contract_signed || (req.links && req.links.contract_signed) ? 'Subido' : 'Pendiente') : 'No aplica' }}</td>
                    <td>{{ formatDate(req.submitted_at) }}</td>
                    <td @click.stop>
                      <button :disabled="req.status !== 'SUBMITTED'" @click.stop="approveOnboarding(req.id)">Aprobar</button>
                      <button :disabled="req.status === 'APPROVED'" @click.stop="rejectOnboarding(req.id)">Rechazar</button>
                    </td>
                  </tr>
                  <tr :key="`onb-details-${req.id}`" class="detail-row" v-if="isRowExpanded(`onb-${req.id}`)">
                    <td colspan="8">
                      <div v-if="onboardingDetailLoading[req.id]">Cargando detalle...</div>
                      <div v-else-if="onboardingDetailErrors[req.id]" class="inline-error">
                        {{ onboardingDetailErrors[req.id] }}
                        <button type="button" @click.stop="fetchOnboardingRequestDetail(req.id)">Reintentar</button>
                      </div>
                      <template v-else-if="req._detailLoaded">
                      <div class="onboarding-details-grid">
                        <section class="onboarding-card">
                          <h4>Perfil y Estado</h4>
                          <div class="onboarding-profile-preview">
                            <div class="onboarding-profile-circle" :class="{ empty: !(req.links && req.links.profile_photo) }">
                              <img
                                v-if="req.links && req.links.profile_photo"
                                :src="req.links.profile_photo"
                                :alt="`Foto de perfil de ${req.nombre || ''} ${req.apellido || ''}`"
                              >
                              <span v-else>{{ getOnboardingInitials(req) }}</span>
                            </div>
                            <div>
                              <strong>Foto de perfil</strong>
                              <div class="profile-preview-meta">
                                {{ req.links && req.links.profile_photo ? 'Cargada por el profesional' : 'Sin foto cargada' }}
                              </div>
                            </div>
                          </div>
                          <div class="identity-editor" @click.stop>
                            <label>
                              Nombre
                              <input
                                :value="getOnboardingIdentityDraft(req.id, 'nombre', req.nombre)"
                                :disabled="req.status === 'APPROVED' || isOnboardingIdentitySaving(req.id)"
                                @input="setOnboardingIdentityDraft(req.id, 'nombre', $event.target.value)"
                              >
                            </label>
                            <label>
                              Apellido
                              <input
                                :value="getOnboardingIdentityDraft(req.id, 'apellido', req.apellido)"
                                :disabled="req.status === 'APPROVED' || isOnboardingIdentitySaving(req.id)"
                                @input="setOnboardingIdentityDraft(req.id, 'apellido', $event.target.value)"
                              >
                            </label>
                            <button
                              type="button"
                              :disabled="req.status === 'APPROVED' || isOnboardingIdentitySaving(req.id) || !hasOnboardingIdentityChanges(req)"
                              @click.stop="saveOnboardingIdentity(req)"
                            >
                              {{ isOnboardingIdentitySaving(req.id) ? 'Guardando...' : 'Guardar nombre' }}
                            </button>
                            <small v-if="req.status === 'APPROVED'" class="identity-help">No editable cuando ya está aprobado.</small>
                            <small v-else class="identity-help">Si es independiente, al cambiar nombre/apellido se debe realizar nuevamente la validación de datos.</small>
                            <div v-if="onboardingIdentityErrors[req.id]" class="inline-error">{{ onboardingIdentityErrors[req.id] }}</div>
                          </div>
                          <div class="kv-list">
                            <div><strong>RUT:</strong> {{ req.rut || 'N/A' }}</div>
                            <div><strong>Teléfono:</strong> {{ req.telefono || 'N/A' }}</div>
                            <div><strong>Descripción:</strong> {{ req.descripcion_personal || 'N/A' }}</div>
                            <div><strong>Empresa en un día:</strong> {{ formatBoolean(req.empresa_en_un_dia) }}</div>
                            <div><strong>Empresa con personal:</strong> {{ formatBoolean(req.empresa_con_personal) }}</div>
                            <div><strong>Declaración jurada aceptada:</strong> {{ formatBoolean(req.declaracion_jurada_simple_aceptada) }}</div>
                            <div><strong>Texto declaración:</strong> {{ req.declaracion_jurada_simple_texto || 'N/A' }}</div>
                            <div><strong>Estado:</strong> {{ req.status || 'N/A' }}</div>
                            <div><strong>Enviado:</strong> {{ formatDate(req.submitted_at) }}</div>
                            <div><strong>Última actualización:</strong> {{ formatDate(req.updated_at) }}</div>
                            <div><strong>Notas revisión:</strong> {{ req.review_notes || 'Sin notas' }}</div>
                            <div><strong>Razón rechazo:</strong> {{ req.rejection_reason || 'N/A' }}</div>
                          </div>
                        </section>

                        <section v-if="shouldShowOnboardingSiiCard(req)" class="onboarding-card">
                          <h4>Revision SII</h4>
                          <div class="kv-list">
                            <div>
                              <strong>Estado:</strong>
                              <span class="pill" :class="siiValidationStatusClass(req.sii_validacion_estado)">
                                {{ formatSiiValidationStatus(req.sii_validacion_estado) }}
                              </span>
                            </div>
                            <div><strong>RUT validado:</strong> {{ req.sii_rut_consultado || getOnboardingSiiTargetRut(req) || 'N/A' }}</div>
                            <div><strong>Nombre SII:</strong> {{ req.sii_nombre || 'N/A' }}</div>
                            <div><strong>Fecha validacion:</strong> {{ formatDate(req.sii_validacion_fecha) }}</div>
                            <div v-if="req.sii_validacion_motivo" class="sii-review-reason">
                              {{ req.sii_validacion_motivo }}
                            </div>
                          </div>
                          <button
                            v-if="canManuallyApproveSii(req)"
                            type="button"
                            class="sii-manual-approve-button"
                            :disabled="isSiiApprovalSaving(req.id)"
                            @click.stop="approveSiiReviewManually(req)"
                          >
                            {{ isSiiApprovalSaving(req.id) ? 'Aprobando...' : 'Aprobar revision SII' }}
                          </button>
                          <div v-if="siiApprovalErrors[req.id]" class="inline-error">{{ siiApprovalErrors[req.id] }}</div>
                        </section>

                        <section v-if="requiresContract(req)" class="onboarding-card">
                          <h4>Datos Bancarios</h4>
                          <div class="kv-list">
                            <div><strong>Titular cuenta:</strong> {{ req.nombre_transferencia || 'N/A' }}</div>
                            <div><strong>RUT titular:</strong> {{ req.rut_transferencia || 'N/A' }}</div>
                            <div><strong>Banco:</strong> {{ req.banco_nombre || req.banco_id || 'N/A' }}</div>
                            <div><strong>Tipo cuenta:</strong> {{ req.tipo_cuenta_nombre || req.tipo_cuenta_id || 'N/A' }}</div>
                            <div><strong>Cuenta bancaria:</strong> {{ req.cuenta_bancaria || 'N/A' }}</div>
                          </div>
                        </section>
                        <section v-else class="onboarding-card">
                          <h4>Datos Bancarios</h4>
                          <div class="kv-list">
                            <div>No aplica para este registro.</div>
                          </div>
                        </section>

                        <section class="onboarding-card">
                          <h4>Categorías</h4>
                          <div class="chip-list">
                            <span v-for="cat in req.categorias" :key="`cat-${req.id}-${cat.id}`" class="chip">{{ cat.nombre }}</span>
                            <span v-if="!(req.categorias && req.categorias.length)">Sin categorías</span>
                          </div>
                        </section>

                        <section class="onboarding-card">
                          <h4>Documentos</h4>
                          <div class="doc-list">
                            <template v-for="doc in getDocumentItems(req)">
                              <a
                                v-if="doc.url"
                                :key="`${req.id}-${doc.key}-link`"
                                :href="doc.url"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {{ doc.label }}
                              </a>
                              <span v-else :key="`${req.id}-${doc.key}-missing`" class="doc-missing">{{ doc.label }} pendiente</span>
                            </template>
                          </div>
                        </section>
                      </div>

                      <section class="onboarding-card">
                        <h4>Trabajos y Evidencia</h4>
                        <div v-for="trabajo in req.trabajos" :key="`trab-${trabajo.id}`" class="work-item">
                          <div><b>{{ trabajo.nombre }}</b></div>
                          <div class="work-photos">
                            <a v-for="foto in trabajo.fotos" :key="`foto-${foto.id}`" :href="foto.url" target="_blank" rel="noopener noreferrer">Foto {{ foto.id }}</a>
                          </div>
                        </div>
                        <div v-if="!(req.trabajos && req.trabajos.length)">Sin trabajos cargados</div>
                      </section>

                      <section v-if="Object.keys(getExtraOnboardingFields(req)).length" class="onboarding-card">
                        <h4>Campos Adicionales</h4>
                        <div class="kv-list">
                          <div v-for="(value, key) in getExtraOnboardingFields(req)" :key="`extra-${req.id}-${key}`">
                            <strong>{{ humanizeKey(key) }}:</strong> {{ formatUnknownValue(value) }}
                          </div>
                        </div>
                      </section>

                      <div class="mt-2 onboarding-notes">
                        <label><strong>Notas revisión:</strong></label>
                        <input v-model="reviewNotesById[req.id]" placeholder="Notas internas">
                        <input v-model="rejectionReasonById[req.id]" placeholder="Razón rechazo">
                      </div>
                      </template>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>

          <div v-else>
            <div class="onboarding-header">
              <div>
                <h3>Leads de demo Jobbing B2B</h3>
                <p class="onboarding-subtitle">Solicitudes recibidas desde la landing de empresas para coordinar una demo.</p>
              </div>
              <div class="onboarding-count">{{ b2bDemoLeads.length }} leads</div>
            </div>

            <table class="tablex">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Contacto</th>
                  <th>Empresa</th>
                  <th>Email</th>
                  <th>Fecha</th>
                  <th>Fuente</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="lead in b2bDemoLeads" v-if="lead && lead.id">
                  <tr :key="`b2b-${lead.id}`" class="clickable-row" @click="toggleDetails(`b2b-${lead.id}`)">
                    <td>{{ lead.id }}</td>
                    <td>{{ lead.contact_name }}</td>
                    <td>{{ lead.company_name }}</td>
                    <td>{{ lead.contact_email }}</td>
                    <td>{{ formatDate(lead.created_at) }}</td>
                    <td>{{ lead.source_path || '/empresas' }}</td>
                  </tr>
                  <tr v-if="isRowExpanded(`b2b-${lead.id}`)" :key="`b2b-details-${lead.id}`" class="detail-row">
                    <td colspan="6">
                      <div><strong>Información adicional:</strong> {{ lead.additional_information || 'Sin información adicional' }}</div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="articulo-principal">Cargando...</div>
      </div>
    </div>

    <div
      v-if="showAplicanteOnboardingModal"
      class="custom-modal-overlay"
      @click.self="closeAplicanteOnboardingModal"
    >
      <div class="custom-modal">
        <h3>Invitar onboarding</h3>
        <p v-if="aplicanteOnboardingTarget" class="modal-subtitle">
          {{ aplicanteOnboardingTarget.nombre }} {{ aplicanteOnboardingTarget.apellido }} · {{ aplicanteOnboardingTarget.email }}
        </p>
        <div class="form-group">
          <label for="aplicante-onboarding-tipo">Tipo de postulante</label>
          <select
            id="aplicante-onboarding-tipo"
            v-model="aplicanteOnboardingForm.tipo_profesional"
            class="form-control"
          >
            <option value="independiente">Persona natural</option>
            <option value="con_empresa">Empresa</option>
          </select>
        </div>
        <div v-if="aplicanteOnboardingError" class="error-message">{{ aplicanteOnboardingError }}</div>
        <div class="form-actions">
          <button
            type="button"
            class="btn btn-success"
            :disabled="aplicanteOnboardingLoading"
            @click="submitAplicanteOnboardingInvite"
          >
            {{ aplicanteOnboardingLoading ? 'Enviando...' : 'Enviar invitacion' }}
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            :disabled="aplicanteOnboardingLoading"
            @click="closeAplicanteOnboardingModal"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import io from 'socket.io-client';
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';

const COMMON_WHATSAPP_EMOJIS = [
  '😀', '😃', '😄', '😁', '😅', '😂', '🙂', '😉',
  '😊', '😍', '😘', '😎', '🤔', '😮', '😢', '😭',
  '😡', '🙏', '👏', '👍', '👎', '👌', '💪', '🙌',
  '🤝', '✅', '❤️',
];

const FILTERS_STORAGE_KEY = 'jobbing.superadmin.aplicante.filters.v1';

export default {
  name: 'ApplicationManagement',
  components: {
    SideNav,
    TopNav,
  },
  data() {
    return {
      loaded: false,
      activeTab: 'aplicantes',
      applications: [],
      onboardingRequests: [],
      onboardingRequestsError: '',
      onboardingRequestsLoading: false,
      onboardingRequestsLoaded: false,
      onboardingDetailLoading: {},
      onboardingDetailErrors: {},
      b2bDemoLeads: [],
      editing: {},
      expandedRows: [],
      filterFactura: [],
      filterRegion: [],
      filterPhoneType: [],
      filterOnboardingRegion: [],
      selectedFactura: '',
      selectedRegion: '',
      selectedPhone: '',
      selectedOnboardingRegion: '',
      selectedContactStatus: 'all',
      selectedWhatsappReadStatus: 'all',
      selectedOnboardingStatus: 'without',
      reviewNotesById: {},
      rejectionReasonById: {},
      onboardingIdentityDrafts: {},
      onboardingIdentitySaving: {},
      onboardingIdentityErrors: {},
      siiApprovalSaving: {},
      siiApprovalErrors: {},
      aplicanteWhatsappMessages: {},
      aplicanteWhatsappLoading: {},
      aplicanteWhatsappError: {},
      aplicanteWhatsappDrafts: {},
      aplicanteWhatsappSending: {},
      aplicanteWhatsappWarnings: {},
      aplicanteWhatsappEmojiOpen: {},
      commonWhatsappEmojis: COMMON_WHATSAPP_EMOJIS,
      aplicanteWhatsappSocket: null,
      showAplicanteOnboardingModal: false,
      aplicanteOnboardingTarget: null,
      aplicanteOnboardingForm: {
        tipo_profesional: 'independiente',
      },
      aplicanteOnboardingLoading: false,
      aplicanteOnboardingError: '',
    };
  },
  created() {
    this.restoreFilters();
    this.fetchAll();
  },
  methods: {
    restoreFilters() {
      try {
        const stored = JSON.parse(window.localStorage.getItem(FILTERS_STORAGE_KEY) || '{}');
        const facturaValues = ['empresa', 'persona_natural', 'no'];
        const phoneValues = ['android', 'iphone', 'otros'];
        const contactValues = ['all', 'contacted', 'uncontacted'];
        const whatsappReadValues = ['all', 'unread', 'read'];
        const onboardingValues = ['without', 'with', 'all'];

        this.filterFactura = this.normalizeStoredFilters(stored.filterFactura, facturaValues);
        this.filterRegion = this.normalizeStoredFilters(stored.filterRegion);
        this.filterPhoneType = this.normalizeStoredFilters(stored.filterPhoneType, phoneValues);
        this.filterOnboardingRegion = this.normalizeStoredFilters(stored.filterOnboardingRegion);
        this.selectedContactStatus = contactValues.includes(stored.selectedContactStatus)
          ? stored.selectedContactStatus
          : 'all';
        this.selectedWhatsappReadStatus = whatsappReadValues.includes(stored.selectedWhatsappReadStatus)
          ? stored.selectedWhatsappReadStatus
          : 'all';
        this.selectedOnboardingStatus = onboardingValues.includes(stored.selectedOnboardingStatus)
          ? stored.selectedOnboardingStatus
          : 'without';
      } catch (error) {
        console.warn('No se pudieron restaurar los filtros de aplicantes.', error);
      }
    },
    normalizeStoredFilters(values, allowedValues = null) {
      if (!Array.isArray(values)) return [];
      return [...new Set(values.filter(value => (
        value !== ''
        && value !== null
        && typeof value !== 'undefined'
        && (!allowedValues || allowedValues.includes(value))
      )))];
    },
    persistFilters() {
      try {
        window.localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(this.filterStorageState));
      } catch (error) {
        console.warn('No se pudieron guardar los filtros de aplicantes.', error);
      }
    },
    fetchAll() {
      this.loaded = false;
      Promise.all([
        this.fetchApplications(),
        this.fetchB2BDemoLeads(),
      ]).finally(() => {
        this.loaded = true;
      });
    },
    formatOnboardingStatus(status) {
      const value = (status || '').toUpperCase();
      const labels = {
        INVITED: 'Invitado',
        IN_PROGRESS: 'En progreso',
        SUBMITTED: 'Enviado',
        APPROVED: 'Aprobado',
        REJECTED: 'Rechazado',
      };
      return labels[value] || 'Sin onboarding';
    },
    getOnboardingStatusClass(status) {
      const value = (status || '').toUpperCase();
      if (value === 'APPROVED') return 'pill-approved';
      if (value === 'REJECTED') return 'pill-rejected';
      if (value === 'SUBMITTED') return 'pill-submitted';
      if (value === 'IN_PROGRESS') return 'pill-progress';
      if (value === 'INVITED') return 'pill-invited';
      return 'pill-neutral';
    },
    formatOnboardingTipo(tipo) {
      if (tipo === 'con_empresa') return 'Empresa';
      if (tipo === 'independiente') return 'Persona natural';
      return 'Tipo no definido';
    },
    isExpressOnboarding(req) {
      return String(req?.flujo || '').toLowerCase() === 'express_solicitudes';
    },
    requiresContract(req) {
      return !this.isExpressOnboarding(req);
    },
    getOnboardingInitials(req) {
      const first = (req?.nombre || '').trim().charAt(0);
      const last = (req?.apellido || '').trim().charAt(0);
      return ((first || 'J') + (last || 'B')).toUpperCase();
    },
    openAplicanteOnboardingModal(app) {
      if (!app || app.onboarding) return;
      this.aplicanteOnboardingTarget = app;
      this.aplicanteOnboardingForm = {
        tipo_profesional: app.factura_habilitado === 'empresa' ? 'con_empresa' : 'independiente',
      };
      this.aplicanteOnboardingError = '';
      this.aplicanteOnboardingLoading = false;
      this.showAplicanteOnboardingModal = true;
    },
    closeAplicanteOnboardingModal() {
      this.showAplicanteOnboardingModal = false;
      this.aplicanteOnboardingTarget = null;
      this.aplicanteOnboardingLoading = false;
      this.aplicanteOnboardingError = '';
    },
    updateApplicationOnboarding(aplicanteId, onboarding) {
      const app = this.applications.find(item => Number(item.id) === Number(aplicanteId));
      if (app) {
        this.$set(app, 'onboarding', onboarding || null);
      }
    },
    syncOnboardingIdentityDraft(req) {
      if (!req || !req.id) return;
      this.$set(this.onboardingIdentityDrafts, req.id, {
        nombre: req.nombre || '',
        apellido: req.apellido || '',
      });
      this.$set(this.onboardingIdentityErrors, req.id, '');
    },
    getOnboardingIdentityDraft(requestId, field, fallback) {
      const draft = this.onboardingIdentityDrafts[requestId];
      if (!draft) {
        return fallback || '';
      }
      return draft[field] != null ? draft[field] : (fallback || '');
    },
    setOnboardingIdentityDraft(requestId, field, value) {
      const current = this.onboardingIdentityDrafts[requestId] || {};
      this.$set(this.onboardingIdentityDrafts, requestId, {
        ...current,
        [field]: value,
      });
      this.$set(this.onboardingIdentityErrors, requestId, '');
    },
    hasOnboardingIdentityChanges(req) {
      if (!req || !req.id) return false;
      const draft = this.onboardingIdentityDrafts[req.id] || {};
      return (draft.nombre || '').trim() !== (req.nombre || '').trim()
        || (draft.apellido || '').trim() !== (req.apellido || '').trim();
    },
    isOnboardingIdentitySaving(requestId) {
      return !!this.onboardingIdentitySaving[requestId];
    },
    replaceOnboardingRequest(updated) {
      if (!updated || !updated.id) {
        this.fetchOnboardingRequests();
        return;
      }
      const index = this.onboardingRequests.findIndex(item => Number(item.id) === Number(updated.id));
      const existing = index !== -1 ? this.onboardingRequests[index] : null;
      const detailLoaded = !!(
        updated._detailLoaded
        || updated.links
        || (existing && existing._detailLoaded)
      );
      this.$set(updated, '_detailLoaded', detailLoaded);
      if (typeof updated.has_contract_signed === 'undefined') {
        this.$set(
          updated,
          'has_contract_signed',
          !!(updated.contract_signed_s3_key || updated?.links?.contract_signed),
        );
      }
      if (index !== -1) {
        this.$set(this.onboardingRequests, index, updated);
      } else {
        this.onboardingRequests.unshift(updated);
      }
      this.syncOnboardingIdentityDraft(updated);
    },
    normalizeSiiValidationState(state) {
      const value = String(state || '').trim().toLowerCase();
      if (['valid', 'valido', 'validated', 'ok', 'success', 'approved', 'aprobado'].includes(value)) {
        return 'valid';
      }
      if (['review', 'revision', 'manual', 'requires_review'].includes(value)) {
        return 'review';
      }
      if (['error', 'failed', 'fail'].includes(value)) {
        return 'error';
      }
      return value || 'pending';
    },
    formatSiiValidationStatus(state) {
      const value = this.normalizeSiiValidationState(state);
      const labels = {
        valid: 'Validado',
        review: 'Requiere revision',
        error: 'Error',
        pending: 'Pendiente',
      };
      return labels[value] || state || 'Pendiente';
    },
    siiValidationStatusClass(state) {
      const value = this.normalizeSiiValidationState(state);
      if (value === 'valid') return 'pill-approved';
      if (value === 'review') return 'pill-submitted';
      if (value === 'error') return 'pill-rejected';
      return 'pill-neutral';
    },
    getOnboardingSiiTargetRut(req) {
      if (!req) return '';
      return req.tipo_profesional === 'con_empresa' ? (req.empresa_rut || '') : (req.rut || '');
    },
    shouldShowOnboardingSiiCard(req) {
      if (!req) return false;
      return !!(
        this.getOnboardingSiiTargetRut(req)
        || req.sii_validacion_estado
        || req.sii_rut_consultado
        || req.sii_nombre
      );
    },
    canManuallyApproveSii(req) {
      if (!req || String(req.status || '').toUpperCase() === 'APPROVED') return false;
      return !!this.getOnboardingSiiTargetRut(req)
        && this.normalizeSiiValidationState(req.sii_validacion_estado) !== 'valid';
    },
    isSiiApprovalSaving(requestId) {
      return !!this.siiApprovalSaving[requestId];
    },
    approveSiiReviewManually(req) {
      if (!req || !req.id || this.isSiiApprovalSaving(req.id)) return;
      if (!this.getOnboardingSiiTargetRut(req)) {
        this.$set(this.siiApprovalErrors, req.id, 'Este onboarding no tiene RUT para validar.');
        return;
      }
      if (!window.confirm('Aprobar manualmente la revision SII para este RUT?')) {
        return;
      }

      this.$set(this.siiApprovalSaving, req.id, true);
      this.$set(this.siiApprovalErrors, req.id, '');
      axios
        .post(`${window.hostname}api/superadmin/onboarding/requests/${req.id}/sii/manual-approve`, {
          reason: this.reviewNotesById[req.id] || '',
        })
        .then((response) => {
          const updated = response?.data?.request;
          if (updated) {
            this.replaceOnboardingRequest(updated);
          } else {
            this.fetchOnboardingRequests();
          }
          alert('Revision SII aprobada manualmente');
        })
        .catch((error) => {
          const message = error?.response?.data?.message || 'No se pudo aprobar la revision SII.';
          this.$set(this.siiApprovalErrors, req.id, message);
          alert(message);
        })
        .finally(() => {
          this.$set(this.siiApprovalSaving, req.id, false);
        });
    },
    saveOnboardingIdentity(req) {
      if (!req || !req.id || this.isOnboardingIdentitySaving(req.id)) return;
      const draft = this.onboardingIdentityDrafts[req.id] || {};
      const nombre = (draft.nombre || '').trim();
      const apellido = (draft.apellido || '').trim();
      if (!nombre || !apellido) {
        this.$set(this.onboardingIdentityErrors, req.id, 'Nombre y apellido son obligatorios.');
        return;
      }

      this.$set(this.onboardingIdentitySaving, req.id, true);
      this.$set(this.onboardingIdentityErrors, req.id, '');
      axios
        .post(`${window.hostname}api/superadmin/onboarding/requests/${req.id}/identity`, { nombre, apellido })
        .then((response) => {
          const updated = response?.data?.request;
          if (updated && updated.id) {
            this.replaceOnboardingRequest(updated);
          } else {
            this.fetchOnboardingRequests();
          }
        })
        .catch((error) => {
          const message = error?.response?.data?.message || 'No se pudo guardar nombre y apellido.';
          this.$set(this.onboardingIdentityErrors, req.id, message);
        })
        .finally(() => {
          this.$set(this.onboardingIdentitySaving, req.id, false);
        });
    },
    setAplicanteWhatsappUnreadCount(aplicanteId, count) {
      const app = this.applications.find(item => Number(item.id) === Number(aplicanteId));
      if (app) {
        this.$set(app, 'whatsapp_unread_count', Math.max(0, Number(count || 0)));
      }
    },
    markAplicanteWhatsappContacted(aplicanteId, message) {
      const updateContactState = () => {
        const app = this.applications.find(item => Number(item.id) === Number(aplicanteId));
        if (!app) return;
        const currentCount = Number(app.whatsapp_message_count || 0);
        this.$set(app, 'whatsapp_contacted', true);
        this.$set(app, 'whatsapp_message_count', currentCount + 1);
        this.$set(app, 'whatsapp_last_message_at', message?.occurred_at || message?.created_at || new Date().toISOString());
        if (message?.direction === 'inbound') {
          const currentInboundCount = Number(app.whatsapp_inbound_message_count || 0);
          this.$set(app, 'whatsapp_inbound_message_count', currentInboundCount + 1);
          this.$set(app, 'whatsapp_last_inbound_at', message?.occurred_at || message?.created_at || new Date().toISOString());
          if (this.isRowExpanded(`app-${aplicanteId}`)) {
            this.markAplicanteWhatsappRead(aplicanteId);
          } else {
            this.$set(app, 'whatsapp_unread_count', Number(app.whatsapp_unread_count || 0) + 1);
          }
        }
      };

      if (this.isRowExpanded(`app-${aplicanteId}`)) {
        this.preserveAplicanteWhatsappPanelPosition(aplicanteId, updateContactState);
      } else {
        updateContactState();
      }
    },
    submitAplicanteOnboardingInvite() {
      const app = this.aplicanteOnboardingTarget;
      if (!app || !app.id) return;
      if (!this.aplicanteOnboardingForm.tipo_profesional) {
        this.aplicanteOnboardingError = 'Debes seleccionar persona natural o empresa.';
        return;
      }
      this.aplicanteOnboardingLoading = true;
      this.aplicanteOnboardingError = '';
      axios.post(
        `${window.hostname}api/superadmin/aplicantes/${app.id}/onboarding/invite`,
        { tipo_profesional: this.aplicanteOnboardingForm.tipo_profesional },
      )
        .then((response) => {
          this.updateApplicationOnboarding(app.id, response?.data?.onboarding || null);
          alert('Invitacion enviada correctamente.');
          this.closeAplicanteOnboardingModal();
          if (this.onboardingRequestsLoaded) {
            this.fetchOnboardingRequests();
          }
        })
        .catch((error) => {
          const response = error?.response?.data || {};
          if (response.onboarding) {
            this.updateApplicationOnboarding(app.id, response.onboarding);
          }
          this.aplicanteOnboardingError = response.message || 'No se pudo enviar la invitacion.';
        })
        .finally(() => {
          this.aplicanteOnboardingLoading = false;
        });
    },
    getAplicanteWhatsappPanelRef(aplicanteId) {
      return `aplicante-whatsapp-panel-${aplicanteId}`;
    },
    getAplicanteWhatsappMessagesRef(aplicanteId) {
      return `aplicante-whatsapp-messages-${aplicanteId}`;
    },
    getAplicanteWhatsappTextareaRef(aplicanteId) {
      return `aplicante-whatsapp-textarea-${aplicanteId}`;
    },
    getRefElement(refName) {
      const ref = this.$refs[refName];
      return Array.isArray(ref) ? ref[0] : ref;
    },
    getAplicanteWhatsappPanelElement(aplicanteId) {
      return this.getRefElement(this.getAplicanteWhatsappPanelRef(aplicanteId));
    },
    getAplicanteWhatsappMessagesElement(aplicanteId) {
      return this.getRefElement(this.getAplicanteWhatsappMessagesRef(aplicanteId));
    },
    getAplicanteWhatsappTextareaElement(aplicanteId) {
      return this.getRefElement(this.getAplicanteWhatsappTextareaRef(aplicanteId));
    },
    preserveAplicanteWhatsappPanelPosition(aplicanteId, updateFn) {
      if (typeof window === 'undefined') {
        updateFn();
        return;
      }
      const panel = this.getAplicanteWhatsappPanelElement(aplicanteId);
      const topBefore = panel ? panel.getBoundingClientRect().top : null;
      updateFn();
      this.$nextTick(() => {
        const nextPanel = this.getAplicanteWhatsappPanelElement(aplicanteId);
        if (!nextPanel || topBefore === null) return;
        const topAfter = nextPanel.getBoundingClientRect().top;
        const delta = topAfter - topBefore;
        if (Math.abs(delta) > 1) {
          window.scrollBy(0, delta);
        }
      });
    },
    scrollAplicanteWhatsappToBottom(aplicanteId) {
      this.$nextTick(() => {
        const el = this.getAplicanteWhatsappMessagesElement(aplicanteId);
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },
    getWhatsappSocketUrl() {
      return (typeof window !== 'undefined' && window.socket) ? window.socket : '';
    },
    parseSocketPayload(payload) {
      if (!payload) return null;
      if (typeof payload === 'string') {
        try {
          return JSON.parse(payload);
        } catch (error) {
          console.warn('Socket payload invalido', error);
          return null;
        }
      }
      return payload;
    },
    connectAplicanteWhatsappSocket(force = false) {
      const url = this.getWhatsappSocketUrl();
      if (!url || !this.token || !this.admin_datos || !this.admin_datos.superadmin) {
        this.closeAplicanteWhatsappSocket();
        return;
      }
      if (force) {
        this.closeAplicanteWhatsappSocket();
      }
      if (this.aplicanteWhatsappSocket) return;

      this.aplicanteWhatsappSocket = io(url, {
        extraHeaders: {
          token: this.token,
          tipo: 'admin',
          usuario: JSON.stringify(this.admin_datos || {}),
        },
      });
      this.aplicanteWhatsappSocket.on('aplicante_whatsapp_event', this.handleAplicanteWhatsappSocketEvent);
    },
    closeAplicanteWhatsappSocket() {
      if (!this.aplicanteWhatsappSocket) return;
      this.aplicanteWhatsappSocket.off('aplicante_whatsapp_event', this.handleAplicanteWhatsappSocketEvent);
      this.aplicanteWhatsappSocket.disconnect();
      this.aplicanteWhatsappSocket = null;
    },
    handleAplicanteWhatsappSocketEvent(rawPayload) {
      const payload = this.parseSocketPayload(rawPayload);
      const aplicanteId = Number(payload?.aplicante_id);
      if (!Number.isFinite(aplicanteId) || aplicanteId <= 0) return;

      if (payload.message) {
        const appended = this.appendAplicanteWhatsappMessage(aplicanteId, payload.message);
        if (appended) {
          this.markAplicanteWhatsappContacted(aplicanteId, payload.message);
        }
      } else if (this.isRowExpanded(`app-${aplicanteId}`)) {
        this.fetchAplicanteWhatsappConversation(aplicanteId, { force: true });
      }
    },
    appendAplicanteWhatsappMessage(aplicanteId, message) {
      if (!aplicanteId || !message) return false;
      const currentMessages = this.getAplicanteWhatsappMessages(aplicanteId);
      if (currentMessages.some((item) => item && item.id === message.id)) {
        this.scrollAplicanteWhatsappToBottom(aplicanteId);
        return false;
      }
      this.$set(this.aplicanteWhatsappMessages, aplicanteId, [...currentMessages, message]);
      this.scrollAplicanteWhatsappToBottom(aplicanteId);
      return true;
    },
    async markAplicanteWhatsappRead(aplicanteId) {
      if (!aplicanteId) return;
      try {
        const resp = await axios.post(`${window.hostname}api/superadmin/aplicantes/${aplicanteId}/whatsapp_messages/read`);
        this.setAplicanteWhatsappUnreadCount(aplicanteId, resp?.data?.whatsapp_unread_count || 0);
      } catch (err) {
        console.error('Error marcando WhatsApp de aplicante como leido', err);
      }
    },
    async fetchAplicanteWhatsappConversation(aplicanteId, { force = false } = {}) {
      if (!aplicanteId) return;
      if (!force && this.aplicanteWhatsappMessages[aplicanteId]) {
        await this.markAplicanteWhatsappRead(aplicanteId);
        return;
      }
      this.$set(this.aplicanteWhatsappLoading, aplicanteId, true);
      this.$set(this.aplicanteWhatsappError, aplicanteId, null);
      try {
        const resp = await axios.get(`${window.hostname}api/superadmin/aplicantes/${aplicanteId}/whatsapp_messages`);
        const messages = Array.isArray(resp?.data?.messages) ? resp.data.messages : [];
        this.$set(this.aplicanteWhatsappMessages, aplicanteId, messages);
        this.$set(this.aplicanteWhatsappWarnings, aplicanteId, resp?.data?.context_warnings || []);
        this.scrollAplicanteWhatsappToBottom(aplicanteId);
        await this.markAplicanteWhatsappRead(aplicanteId);
      } catch (err) {
        console.error('Error cargando WhatsApp de aplicante', err);
        this.$set(this.aplicanteWhatsappError, aplicanteId, 'No se pudo cargar la conversacion de WhatsApp.');
      } finally {
        this.$set(this.aplicanteWhatsappLoading, aplicanteId, false);
      }
    },
    getAplicanteWhatsappMessages(aplicanteId) {
      return this.aplicanteWhatsappMessages[aplicanteId] || [];
    },
    getAplicanteWhatsappWarnings(aplicanteId) {
      return this.aplicanteWhatsappWarnings[aplicanteId] || [];
    },
    getAplicanteWhatsappDraft(aplicanteId) {
      return this.aplicanteWhatsappDrafts[aplicanteId] || '';
    },
    setAplicanteWhatsappDraft(aplicanteId, value) {
      this.$set(this.aplicanteWhatsappDrafts, aplicanteId, value || '');
    },
    capitalizeWords(value) {
      return (value || '')
        .toString()
        .trim()
        .toLocaleLowerCase('es-CL')
        .replace(/\s+/g, ' ')
        .replace(/(^|\s)(\S)/g, (match, space, letter) => `${space}${letter.toLocaleUpperCase('es-CL')}`);
    },
    getAplicanteFirstName(app) {
      const firstName = (app?.nombre || '').toString().trim().split(/\s+/)[0] || 'Hola';
      return this.capitalizeWords(firstName);
    },
    getAdminFirstName() {
      const firstName = (this.admin_datos?.nombre || '').toString().trim().split(/\s+/)[0] || 'Jobbing';
      return this.capitalizeWords(firstName);
    },
    getAplicanteInitialContactMessage(app) {
      return `Hola ${this.getAplicanteFirstName(app)}, ¿cómo estás? Soy ${this.getAdminFirstName()} de Jobbing, la plataforma que conecta clientes con profesionales para servicios del hogar. Vimos tu postulación.\n\n¿Tienes unos minutos para reunirnos y mostrarte cómo funciona la plataforma?\n\nSaludos.`;
    },
    isAplicanteWhatsappEmojiOpen(aplicanteId) {
      return !!this.aplicanteWhatsappEmojiOpen[aplicanteId];
    },
    toggleAplicanteWhatsappEmojiPicker(aplicanteId) {
      const nextValue = !this.isAplicanteWhatsappEmojiOpen(aplicanteId);
      this.aplicanteWhatsappEmojiOpen = {};
      this.$set(this.aplicanteWhatsappEmojiOpen, aplicanteId, nextValue);
    },
    closeAplicanteWhatsappEmojiPicker(aplicanteId) {
      this.$set(this.aplicanteWhatsappEmojiOpen, aplicanteId, false);
    },
    insertAplicanteWhatsappEmoji(aplicanteId, emoji) {
      if (!aplicanteId || !emoji || this.isAplicanteWhatsappSending(aplicanteId)) return;
      const currentDraft = this.getAplicanteWhatsappDraft(aplicanteId);
      const textarea = this.getAplicanteWhatsappTextareaElement(aplicanteId);
      const start = textarea ? textarea.selectionStart : currentDraft.length;
      const end = textarea ? textarea.selectionEnd : currentDraft.length;
      const nextDraft = `${currentDraft.slice(0, start)}${emoji}${currentDraft.slice(end)}`;
      const nextCursorPosition = start + emoji.length;

      this.setAplicanteWhatsappDraft(aplicanteId, nextDraft);
      this.$nextTick(() => {
        const nextTextarea = this.getAplicanteWhatsappTextareaElement(aplicanteId);
        if (!nextTextarea) return;
        nextTextarea.focus();
        nextTextarea.setSelectionRange(nextCursorPosition, nextCursorPosition);
      });
    },
    isAplicanteWhatsappLoading(aplicanteId) {
      return !!this.aplicanteWhatsappLoading[aplicanteId];
    },
    isAplicanteWhatsappSending(aplicanteId) {
      return !!this.aplicanteWhatsappSending[aplicanteId];
    },
    getAplicanteWhatsappError(aplicanteId) {
      return this.aplicanteWhatsappError[aplicanteId] || null;
    },
    canSendAplicanteWhatsapp(aplicanteId) {
      return !!this.getAplicanteWhatsappDraft(aplicanteId).trim()
        && !this.isAplicanteWhatsappSending(aplicanteId);
    },
    canSendAplicanteWhatsappText(aplicanteId, messageText) {
      return !!(messageText || '').trim() && !this.isAplicanteWhatsappSending(aplicanteId);
    },
    async sendAplicanteWhatsappText(app, messageText, { clearDraft = false, alertOnError = false } = {}) {
      const aplicanteId = app?.id;
      if (!aplicanteId || !this.canSendAplicanteWhatsappText(aplicanteId, messageText)) return;
      const trimmedMessage = messageText.trim();
      this.$set(this.aplicanteWhatsappSending, aplicanteId, true);
      this.$set(this.aplicanteWhatsappError, aplicanteId, null);
      try {
        const resp = await axios.post(
          `${window.hostname}api/superadmin/aplicantes/${aplicanteId}/whatsapp_messages`,
          { message: trimmedMessage },
        );
        if (resp?.data?.message) {
          const appended = this.appendAplicanteWhatsappMessage(aplicanteId, resp.data.message);
          if (appended) {
            this.markAplicanteWhatsappContacted(aplicanteId, resp.data.message);
          }
        }
        this.$set(this.aplicanteWhatsappWarnings, aplicanteId, resp?.data?.context_warnings || []);
        if (clearDraft) {
          this.setAplicanteWhatsappDraft(aplicanteId, '');
        }
        this.closeAplicanteWhatsappEmojiPicker(aplicanteId);
        await this.fetchAplicanteWhatsappConversation(aplicanteId, { force: true });
      } catch (err) {
        console.error('Error enviando WhatsApp de aplicante', err);
        const message = err.response?.data?.message || 'No se pudo enviar el WhatsApp.';
        this.$set(this.aplicanteWhatsappError, aplicanteId, message);
        if (alertOnError) {
          alert(message);
        }
      } finally {
        this.$set(this.aplicanteWhatsappSending, aplicanteId, false);
      }
    },
    async sendAplicanteWhatsappMessage(app) {
      const aplicanteId = app?.id;
      if (!aplicanteId || !this.canSendAplicanteWhatsapp(aplicanteId)) return;
      await this.sendAplicanteWhatsappText(app, this.getAplicanteWhatsappDraft(aplicanteId), { clearDraft: true });
    },
    async sendAplicanteWhatsappInitialContact(app) {
      await this.sendAplicanteWhatsappText(
        app,
        this.getAplicanteInitialContactMessage(app),
        { alertOnError: true },
      );
    },
    mapWhatsappSenderLabel(message) {
      const metadata = message?.metadata_json || {};
      if (message?.direction === 'inbound') {
        return 'Postulante';
      }
      return metadata.admin_label || 'Equipo Jobbing';
    },
    mapWhatsappSenderClass(message) {
      return message?.direction === 'inbound' ? 'inbound' : 'outbound';
    },
    getWhatsappMessageText(message) {
      return message?.text || message?.preview || '';
    },
    parseDateTimestamp(dateString) {
      if (!dateString) return 0;
      const date = new Date(dateString);
      return Number.isNaN(date.getTime()) ? 0 : date.getTime();
    },
    compareApplicationsByWhatsappInbound(a, b) {
      const aLastInbound = this.parseDateTimestamp(a?.whatsapp_last_inbound_at);
      const bLastInbound = this.parseDateTimestamp(b?.whatsapp_last_inbound_at);
      const aHasInbound = aLastInbound > 0;
      const bHasInbound = bLastInbound > 0;
      const aCreatedAt = this.parseDateTimestamp(a?.created_at);
      const bCreatedAt = this.parseDateTimestamp(b?.created_at);
      const aSortAt = aLastInbound || aCreatedAt;
      const bSortAt = bLastInbound || bCreatedAt;

      if (aSortAt !== bSortAt) {
        return bSortAt - aSortAt;
      }
      if (aHasInbound !== bHasInbound) {
        return aHasInbound ? -1 : 1;
      }

      return Number(b?.id || 0) - Number(a?.id || 0);
    },
    fetchApplications() {
      return axios
        .get(`${window.hostname}api/superadmin/get_applications`)
        .then((response) => {
          if (response.data && Array.isArray(response.data.applications)) {
            this.applications = response.data.applications
              .filter(app => app && app.id);
            this.applications.forEach(app => {
              this.$set(this.editing, app.id, false);
            });
          } else {
            this.applications = [];
          }
        })
        .catch((e) => {
          console.error('Error al cargar aplicaciones...', e);
          this.applications = [];
        });
    },
    fetchOnboardingRequests() {
      if (this.onboardingRequestsLoading) {
        return Promise.resolve();
      }
      this.onboardingRequestsError = '';
      this.onboardingRequestsLoading = true;
      return axios
        .get(`${window.hostname}api/superadmin/onboarding/requests`)
        .then((response) => {
          const rows = response?.data?.requests;
          this.onboardingRequests = Array.isArray(rows)
            ? rows.map(req => ({ ...req, _detailLoaded: false }))
            : [];
          this.expandedRows = this.expandedRows.filter(key => !key.startsWith('onb-'));
          this.onboardingRequests.forEach((req) => this.syncOnboardingIdentityDraft(req));
        })
        .catch((e) => {
          console.error('Error cargando onboarding requests', e);
          this.onboardingRequestsError = e?.response?.data?.message || 'No se pudieron cargar las solicitudes de onboarding.';
          this.onboardingRequests = [];
        })
        .finally(() => {
          this.onboardingRequestsLoading = false;
          this.onboardingRequestsLoaded = true;
        });
    },
    fetchOnboardingRequestDetail(requestId) {
      if (!requestId || this.onboardingDetailLoading[requestId]) {
        return Promise.resolve();
      }
      this.$set(this.onboardingDetailLoading, requestId, true);
      this.$set(this.onboardingDetailErrors, requestId, '');
      return axios
        .get(`${window.hostname}api/superadmin/onboarding/requests/${requestId}`)
        .then((response) => {
          const updated = response?.data?.request;
          if (!updated || !updated.id) {
            throw new Error('Respuesta de detalle invalida');
          }
          this.$set(updated, '_detailLoaded', true);
          this.replaceOnboardingRequest(updated);
        })
        .catch((e) => {
          console.error('Error cargando detalle de onboarding', e);
          this.$set(
            this.onboardingDetailErrors,
            requestId,
            e?.response?.data?.message || 'No se pudo cargar el detalle del onboarding.',
          );
        })
        .finally(() => {
          this.$set(this.onboardingDetailLoading, requestId, false);
        });
    },
    fetchB2BDemoLeads() {
      return axios
        .get(`${window.hostname}api/superadmin/jobbing_b2b_demo_leads`)
        .then((response) => {
          const rows = response?.data?.leads;
          this.b2bDemoLeads = Array.isArray(rows) ? rows : [];
        })
        .catch((e) => {
          console.error('Error cargando leads B2B', e);
          this.b2bDemoLeads = [];
        });
    },
    approveOnboarding(requestId) {
      const review_notes = this.reviewNotesById[requestId] || '';
      axios
        .post(`${window.hostname}api/superadmin/onboarding/requests/${requestId}/approve`, { review_notes })
        .then((response) => {
          alert('Onboarding aprobado');
          this.replaceOnboardingRequest(response?.data?.request);
        })
        .catch((e) => {
          const msg = e?.response?.data?.message || 'No se pudo aprobar onboarding';
          alert(msg);
        });
    },
    rejectOnboarding(requestId) {
      const review_notes = this.reviewNotesById[requestId] || '';
      const rejection_reason = this.rejectionReasonById[requestId] || '';
      axios
        .post(`${window.hostname}api/superadmin/onboarding/requests/${requestId}/reject`, { review_notes, rejection_reason })
        .then((response) => {
          alert('Onboarding rechazado');
          this.replaceOnboardingRequest(response?.data?.request);
        })
        .catch((e) => {
          const msg = e?.response?.data?.message || 'No se pudo rechazar onboarding';
          alert(msg);
        });
    },
    addFactura() {
      if (this.selectedFactura && !this.filterFactura.includes(this.selectedFactura)) {
        this.filterFactura.push(this.selectedFactura);
      }
      this.selectedFactura = '';
    },
    removeFactura(value) {
      this.filterFactura = this.filterFactura.filter(f => f !== value);
    },
    addRegion() {
      if (this.selectedRegion && !this.filterRegion.includes(this.selectedRegion)) {
        this.filterRegion.push(this.selectedRegion);
      }
      this.selectedRegion = '';
    },
    removeRegion(value) {
      this.filterRegion = this.filterRegion.filter(r => r !== value);
    },
    addOnboardingRegion() {
      if (
        this.selectedOnboardingRegion
        && !this.filterOnboardingRegion.includes(this.selectedOnboardingRegion)
      ) {
        this.filterOnboardingRegion.push(this.selectedOnboardingRegion);
      }
      this.selectedOnboardingRegion = '';
    },
    removeOnboardingRegion(value) {
      this.filterOnboardingRegion = this.filterOnboardingRegion.filter(r => r !== value);
    },
    addPhone() {
      if (this.selectedPhone && !this.filterPhoneType.includes(this.selectedPhone)) {
        this.filterPhoneType.push(this.selectedPhone);
      }
      this.selectedPhone = '';
    },
    removePhone(value) {
      this.filterPhoneType = this.filterPhoneType.filter(p => p !== value);
    },
    getRegionName(id) {
      const region = this.regiones.find(r => Number(r.id) === Number(id));
      return region ? region.Nombre : id;
    },
    formatFactura(value) {
      const map = { empresa: 'Empresa', persona_natural: 'Persona Natural', no: 'No' };
      return map[value] || value;
    },
    formatPhone(value) {
      const map = { android: 'Android', iphone: 'iPhone', otros: 'Otros' };
      return map[value] || value;
    },
    formatList(values) {
      if (!Array.isArray(values) || !values.length) {
        return 'No especificado';
      }
      return values.filter(Boolean).join(', ') || 'No especificado';
    },
    toggleDetails(key) {
      const index = this.expandedRows.indexOf(key);
      if (index > -1) {
        this.expandedRows.splice(index, 1);
      } else {
        this.expandedRows.push(key);
        if (key.startsWith('app-')) {
          const aplicanteId = Number(key.replace('app-', ''));
          if (Number.isFinite(aplicanteId) && aplicanteId > 0) {
            this.fetchAplicanteWhatsappConversation(aplicanteId)
              .then(() => this.scrollAplicanteWhatsappToBottom(aplicanteId));
          }
        }
      }
    },
    toggleOnboardingDetails(req) {
      if (!req || !req.id) return;
      const key = `onb-${req.id}`;
      const wasExpanded = this.isRowExpanded(key);
      this.toggleDetails(key);
      if (!wasExpanded && !req._detailLoaded) {
        this.fetchOnboardingRequestDetail(req.id);
      }
    },
    isRowExpanded(key) {
      return this.expandedRows.includes(key);
    },
    markAsReviewed(applicationId) {
      axios
        .post(`${window.hostname}api/superadmin/mark_as_reviewed`, { id: applicationId })
        .then(() => {
          alert('Aplicación marcada como revisada');
        })
        .catch((e) => {
          console.error('Error al marcar como revisado', e);
        });
    },
    assignProfessional(applicationId) {
      if (!applicationId) {
        return;
      }
      alert('Función para asignar un profesional no implementada.');
    },
    startEditing(appId) {
      this.$set(this.editing, appId, true);
    },
    cancelEditing(appId) {
      this.$set(this.editing, appId, false);
    },
    saveComentarios(applicationId, newComentarios) {
      axios
        .post(`${window.hostname}api/superadmin/update_comentarios`, { id: applicationId, comentarios: newComentarios })
        .then(() => {
          alert('Comentarios actualizados');
          this.$set(this.editing, applicationId, false);
        })
        .catch((e) => {
          console.error('Error al actualizar comentarios', e);
        });
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      if (Number.isNaN(date.getTime())) return 'N/A';
      return date.toLocaleDateString('es-CL', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
    formatDateTime(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      if (Number.isNaN(date.getTime())) return 'N/A';
      return date.toLocaleString('es-CL', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    statusClass(status) {
      const value = (status || '').toUpperCase();
      if (value === 'APPROVED') return 'pill-approved';
      if (value === 'REJECTED') return 'pill-rejected';
      if (value === 'SUBMITTED') return 'pill-submitted';
      return 'pill-neutral';
    },
    humanizeKey(key) {
      if (!key) return '';
      return key
        .toString()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());
    },
    formatUnknownValue(value) {
      if (value === null || typeof value === 'undefined' || value === '') return 'N/A';
      if (typeof value === 'object') return JSON.stringify(value);
      return value;
    },
    formatBoolean(value) {
      if (value === true) return 'Sí';
      if (value === false) return 'No';
      return 'N/A';
    },
    getDocumentItems(req) {
      const labels = {
        carnet_front: 'Carnet frente',
        carnet_back: 'Carnet reverso',
        antecedentes: 'Certificado antecedentes',
        profile_photo: 'Foto de perfil',
        empresa_logo: 'Logo empresa o marca',
        estatuto_actualizado_vigencia: 'Estatuto actualizado (Empresa en un Día)',
        vigencia_empresa_un_dia: 'Vigencia (Empresa en un Día)',
        vigencia_sociedad: 'Vigencia de sociedad',
        vigencia_poderes: 'Vigencia de poderes',
        certificado_tributario: 'Certificado tributario',
        representante_cedula_front: 'Cédula representante legal (frente)',
        representante_cedula_back: 'Cédula representante legal (reverso)',
        visita_cedula_front: 'Cédula visita presencial (frente)',
        visita_cedula_back: 'Cédula visita presencial (reverso)',
        visita_antecedentes: 'Antecedentes visita presencial',
        visita_foto: 'Foto visita presencial',
        visita_carnet_sec: 'Carnet SEC',
        acreditacion_f30: 'Acreditación laboral F30',
        acreditacion_f30_1: 'Acreditación previsional F30-1',
        declaracion_jurada_simple: 'Declaración jurada simple',
        contract_signed: 'Acuerdo comercial firmado',
      };

      let keys = Object.keys(labels);
      if (this.isExpressOnboarding(req)) {
        keys = ['antecedentes'];
        ['profile_photo', 'empresa_logo', 'carnet_front', 'carnet_back'].forEach((optionalKey) => {
          if (req?.links?.[optionalKey]) {
            keys.push(optionalKey);
          }
        });
      }
      if (!this.isExpressOnboarding(req) && req?.links?.empresa_logo) {
        keys.push('empresa_logo');
      }

      return keys.map((key) => ({
        key,
        label: labels[key],
        url: req?.links?.[key] || '',
      }));
    },
    getExtraOnboardingFields(req) {
      const ignored = new Set([
        'id',
        'nombre',
        'apellido',
        'email',
        'tipo_profesional',
        'status',
        'submitted_at',
        'updated_at',
        'rut',
        'descripcion_personal',
        'nombre_transferencia',
        'rut_transferencia',
        'banco_nombre',
        'banco_id',
        'tipo_cuenta_nombre',
        'tipo_cuenta_id',
        'cuenta_bancaria',
        'review_notes',
        'rejection_reason',
        'categorias',
        'links',
        'trabajos',
        'has_contract_signed',
        '_detailLoaded',
      ]);
      const extras = {};
      Object.keys(req || {}).forEach((key) => {
        if (!ignored.has(key)) {
          extras[key] = req[key];
        }
      });
      return extras;
    },
  },
  computed: {
    ...mapGetters(['admin_datos', 'regiones', 'comunas', 'token']),
    filterStorageState() {
      return {
        filterFactura: this.filterFactura,
        filterRegion: this.filterRegion,
        filterPhoneType: this.filterPhoneType,
        filterOnboardingRegion: this.filterOnboardingRegion,
        selectedContactStatus: this.selectedContactStatus,
        selectedWhatsappReadStatus: this.selectedWhatsappReadStatus,
        selectedOnboardingStatus: this.selectedOnboardingStatus,
      };
    },
    filteredOnboardingRequests() {
      if (!this.filterOnboardingRegion.length) {
        return this.onboardingRequests;
      }

      return this.onboardingRequests.filter((request) => {
        const application = this.applications.find(app => (
          app
          && app.onboarding
          && Number(app.onboarding.id) === Number(request.id)
        ));
        if (!application) return false;

        const applicationRegionIds = (application.comunas || []).map((comunaName) => {
          const comuna = this.comunas.find(item => item.Nombre === comunaName);
          return comuna ? Number(comuna.region) : null;
        });
        return this.filterOnboardingRegion.some(regionId => (
          applicationRegionIds.includes(Number(regionId))
        ));
      });
    },
    onboardingRequestsCountLabel() {
      if (this.filterOnboardingRegion.length) {
        return `${this.filteredOnboardingRequests.length} de ${this.onboardingRequests.length} solicitudes`;
      }
      return `${this.onboardingRequests.length} solicitudes`;
    },
    filteredApplications() {
      return this.applications.filter(app => {
        let facturaOk = true;
        if (this.filterFactura.length) {
          facturaOk = this.filterFactura.includes(app.factura_habilitado);
        }
        let regionOk = true;
        if (this.filterRegion.length) {
          const appRegionIds = (app.comunas || []).map(nombre => {
            const comuna = this.comunas.find(c => c.Nombre === nombre);
            return comuna ? comuna.region : null;
          });
          regionOk = this.filterRegion.some(r => appRegionIds.includes(Number(r)));
        }
        let phoneOk = true;
        if (this.filterPhoneType.length) {
          phoneOk = this.filterPhoneType.includes((app.tipo_telefono || '').toLowerCase());
        }
        let contactOk = true;
        if (this.selectedContactStatus === 'contacted') {
          contactOk = !!app.whatsapp_contacted;
        } else if (this.selectedContactStatus === 'uncontacted') {
          contactOk = !app.whatsapp_contacted;
        }
        let whatsappReadOk = true;
        const unreadCount = Number(app.whatsapp_unread_count || 0);
        if (this.selectedWhatsappReadStatus === 'unread') {
          whatsappReadOk = unreadCount > 0;
        } else if (this.selectedWhatsappReadStatus === 'read') {
          whatsappReadOk = unreadCount === 0;
        }
        let onboardingOk = true;
        if (this.selectedOnboardingStatus === 'with') {
          onboardingOk = !!app.onboarding;
        } else if (this.selectedOnboardingStatus === 'without') {
          onboardingOk = !app.onboarding;
        }
        return facturaOk && regionOk && phoneOk && contactOk && whatsappReadOk && onboardingOk;
      }).sort((a, b) => this.compareApplicationsByWhatsappInbound(a, b));
    },
  },
  mounted() {
    if (!this.admin_datos.superadmin) {
      this.$router.push('/');
    } else {
      this.connectAplicanteWhatsappSocket();
    }
  },
  beforeDestroy() {
    this.closeAplicanteWhatsappSocket();
  },
  watch: {
    filterStorageState: {
      handler() {
        this.persistFilters();
      },
      deep: true,
    },
    activeTab(newVal) {
      if (newVal === 'onboarding' && !this.onboardingRequestsLoaded) {
        this.fetchOnboardingRequests();
      }
    },
    admin_datos(newVal, oldVal) {
      if (newVal && newVal.superadmin && (!oldVal || !oldVal.superadmin)) {
        this.connectAplicanteWhatsappSocket(true);
      } else if (!newVal || !newVal.superadmin) {
        this.closeAplicanteWhatsappSocket();
      }
    },
    token(newVal, oldVal) {
      if (newVal && newVal !== oldVal && this.admin_datos && this.admin_datos.superadmin) {
        this.connectAplicanteWhatsappSocket(true);
      }
    },
  },
};
</script>

<style scoped>
.tablex th, .tablex td {
  text-align: left;
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

.tablex th {
  background-color: rgb(38, 53, 67);
  color: white;
}

.tablex {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
}

.column-right {
  background-color: rgb(242, 247, 251);
  padding-top: 80px;
  padding-left: 260px;
  width: 100%;
}

.main-container {
  background-color: white;
  margin-top: 10px;
  padding: 20px;
}

.detail-row td {
  background-color: #f9f9f9;
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: #f1f1f1;
}

.filters {
  margin-bottom: 15px;
}

.filter-group {
  margin-right: 15px;
  display: inline-block;
}

.tags {
  margin-top: 5px;
}

.tag {
  background-color: #e0e0e0;
  border-radius: 3px;
  padding: 2px 6px;
  margin-right: 5px;
  margin-top: 5px;
  display: inline-block;
}

.remove-tag {
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: 4px;
}

.services-cell {
  max-width: 220px;
  line-height: 1.35;
}

.tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.tab-btn {
  border: 1px solid #d8d8d8;
  background: #f2f2f2;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
}

.tab-btn.active {
  background: #007bff;
  color: #fff;
  border-color: #007bff;
}

.onboarding-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.onboarding-header h3 {
  margin: 0;
  color: #1f3b57;
}

.onboarding-subtitle {
  margin: 6px 0 0 0;
  color: #58718a;
}

.onboarding-count {
  background: linear-gradient(120deg, #1c6ea4, #2f89c7);
  color: #fff;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  margin-left: 10px;
}

.onboarding-main-row td {
  vertical-align: middle;
}

.pill {
  display: inline-block;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
}

.pill-submitted {
  background: #fff3cd;
  color: #7d6400;
}

.pill-invited {
  background: #eaf4ff;
  color: #1e4d79;
}

.pill-progress {
  background: #e9d8fd;
  color: #553c9a;
}

.pill-approved {
  background: #d4edda;
  color: #155724;
}

.pill-rejected {
  background: #f8d7da;
  color: #7f1d1d;
}

.pill-neutral {
  background: #e6edf3;
  color: #2b4a67;
}

.onboarding-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.onboarding-card {
  background: #ffffff;
  border: 1px solid #d9e6f2;
  border-radius: 10px;
  padding: 12px;
  margin-top: 10px;
}

.onboarding-card h4 {
  margin: 0 0 8px 0;
  color: #21425f;
}

.onboarding-profile-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4edf6;
}

.onboarding-profile-circle {
  width: 72px;
  height: 72px;
  flex: 0 0 72px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #1c6ea4;
  background: #eaf4ff;
  color: #1c6ea4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 800;
}

.onboarding-profile-circle.empty {
  border-style: dashed;
}

.onboarding-profile-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.profile-preview-meta {
  margin-top: 3px;
  color: #58718a;
  font-size: 12px;
}

.identity-editor {
  display: grid;
  grid-template-columns: minmax(120px, 1fr) minmax(120px, 1fr) auto;
  gap: 8px;
  align-items: end;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4edf6;
}

.identity-editor label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #34516c;
}

.identity-editor input {
  min-width: 0;
  padding: 7px 8px;
  border: 1px solid #cbd8e4;
  border-radius: 4px;
}

.identity-editor button {
  white-space: nowrap;
}

.identity-help,
.inline-error {
  grid-column: 1 / -1;
}

.identity-help {
  color: #58718a;
}

.inline-error {
  color: #b42318;
  font-weight: 700;
}

.kv-list div {
  margin-bottom: 6px;
  line-height: 1.35;
}

.chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  background: #eaf4ff;
  color: #1e4d79;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
}

.doc-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.doc-missing {
  color: #9a6a00;
}

.work-item {
  padding: 6px 0;
  border-bottom: 1px dashed #d9e6f2;
}

.work-item:last-child {
  border-bottom: none;
}

.work-photos {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
}

.onboarding-notes {
  display: flex;
  gap: 8px;
  align-items: center;
}

.onboarding-notes input {
  flex: 1;
}

.sii-review-reason {
  margin-top: 8px;
  border: 1px solid #ffe08a;
  border-radius: 6px;
  padding: 8px 10px;
  color: #7a5a00;
  background: #fff8dc;
}

.sii-manual-approve-button {
  margin-top: 10px;
  border: 1px solid #0f766e;
  border-radius: 6px;
  background: #0f766e;
  color: #ffffff;
  padding: 7px 10px;
  font-weight: 700;
  cursor: pointer;
}

.sii-manual-approve-button:hover:not(:disabled) {
  background: #115e59;
  border-color: #115e59;
}

.sii-manual-approve-button:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.contact-status {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 4px 9px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.contact-status.contacted {
  background: #d1fae5;
  color: #065f46;
}

.contact-meta {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  white-space: nowrap;
}

.unread-badge {
  display: inline-flex;
  margin-top: 5px;
  border-radius: 999px;
  padding: 3px 8px;
  background: #fee2e2;
  color: #991b1b;
  font-size: 12px;
  font-weight: 700;
}

.quick-whatsapp-button {
  display: block;
  margin-top: 6px;
  border: 1px solid #0f766e;
  border-radius: 6px;
  background: #0f766e;
  color: #ffffff;
  padding: 6px 9px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.quick-whatsapp-button:hover:not(:disabled) {
  background: #115e59;
  border-color: #115e59;
}

.quick-whatsapp-button:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.onboarding-invite-button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #0f766e;
  border-radius: 6px;
  background: #0f766e;
  color: #ffffff;
  padding: 7px 10px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}

.onboarding-invite-button:hover:not(:disabled) {
  background: #115e59;
  border-color: #115e59;
}

.onboarding-invite-button:disabled {
  cursor: default;
}

.onboarding-invite-button.associated {
  border-color: #cfd8e3;
  background: #eef5f3;
  color: #48645f;
}

.onboarding-invite-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  font-size: 14px;
  line-height: 1;
}

.onboarding-invite-button.associated .onboarding-invite-icon {
  background: #d7ece7;
  color: #0f766e;
}

.custom-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(24, 38, 51, 0.45);
}

.custom-modal {
  width: min(420px, 100%);
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 18px 40px rgba(24, 38, 51, 0.2);
}

.custom-modal h3 {
  margin: 0 0 8px 0;
  color: #1f3b57;
}

.modal-subtitle {
  margin: 0 0 16px 0;
  color: #58718a;
}

.form-group {
  margin-bottom: 14px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
}

.form-control {
  width: 100%;
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  padding: 8px;
}

.form-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
}

.error-message {
  color: #b42318;
  background: #fff1f0;
  border: 1px solid #ffc9c4;
  border-radius: 6px;
  padding: 8px 10px;
}

.applicant-whatsapp-panel {
  margin-top: 14px;
  border: 1px solid #d9e6f2;
  border-radius: 8px;
  background: #fff;
  padding: 12px;
}

.applicant-whatsapp-panel .panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.applicant-whatsapp-panel h4 {
  margin: 0;
  color: #21425f;
}

.applicant-whatsapp-panel .panel-meta {
  color: #58718a;
  font-weight: 600;
}

.applicant-whatsapp-panel .panel-body {
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid #e7eef7;
  border-radius: 6px;
  padding: 10px;
  background: #fbfdff;
}

.applicant-whatsapp-panel .panel-body.error {
  color: #b42318;
}

.whatsapp-inline-error {
  margin-top: 8px;
  border: 1px solid #ffc9c4;
  border-radius: 6px;
  padding: 8px 10px;
  color: #b42318;
  background: #fff1f0;
}

.applicant-whatsapp-panel .messages {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.applicant-whatsapp-panel .message-row {
  max-width: 78%;
  border: 1px solid #dfe7f0;
  border-radius: 8px;
  padding: 8px 10px;
  background: #ffffff;
}

.applicant-whatsapp-panel .message-row.outbound {
  align-self: flex-end;
  background: #eaf7ef;
  border-color: #ccebd7;
}

.applicant-whatsapp-panel .message-row.inbound {
  align-self: flex-start;
  background: #eef5ff;
  border-color: #d5e5fb;
}

.applicant-whatsapp-panel .message-meta {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #58718a;
  font-size: 12px;
}

.applicant-whatsapp-panel .sender {
  font-weight: 700;
}

.applicant-whatsapp-panel .message-text {
  margin-top: 4px;
  white-space: pre-wrap;
  line-height: 1.4;
}

.applicant-whatsapp-panel .empty-messages {
  color: #58718a;
  font-style: italic;
}

.context-warning {
  margin-bottom: 8px;
  padding: 8px 10px;
  border: 1px solid #ffe08a;
  border-radius: 6px;
  color: #7a5a00;
  background: #fff8dc;
}

.whatsapp-composer-shell {
  margin-top: 10px;
}

.whatsapp-emoji-picker {
  display: grid;
  grid-template-columns: repeat(9, 32px);
  gap: 5px;
  width: max-content;
  max-width: 100%;
  margin-bottom: 8px;
  border: 1px solid #d9e6f2;
  border-radius: 8px;
  padding: 8px;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(31, 59, 87, 0.12);
}

.emoji-option {
  width: 32px;
  height: 32px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: #f8fbff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.emoji-option:hover {
  border-color: #b7cce2;
  background: #eef5ff;
}

.whatsapp-composer {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}

.whatsapp-composer textarea {
  flex: 1;
  min-height: 68px;
  resize: vertical;
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  padding: 8px;
}

.whatsapp-composer-actions {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}

.whatsapp-composer button,
.whatsapp-composer-actions button {
  white-space: nowrap;
}

.emoji-toggle-button {
  min-width: 38px;
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  background: #ffffff;
  padding: 7px 10px;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.emoji-toggle-button.active,
.emoji-toggle-button:hover:not(:disabled) {
  border-color: #7aa7d9;
  background: #eef5ff;
}

.emoji-toggle-button:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

@media (max-width: 800px) {
  .column-right {
    padding-left: 0px;
  }

  .onboarding-header {
    flex-direction: column;
    gap: 8px;
  }

  .onboarding-notes {
    flex-direction: column;
    align-items: stretch;
  }

  .whatsapp-composer {
    flex-direction: column;
    align-items: stretch;
  }

  .whatsapp-emoji-picker {
    grid-template-columns: repeat(6, 32px);
  }

  .whatsapp-composer-actions {
    justify-content: flex-end;
  }

  .applicant-whatsapp-panel .message-row {
    max-width: 100%;
  }
}
</style>
